import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { $host } from '../libs/user-api'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      auth: false,
      layout: 'Empty',
    },
    component: () => import('../views/Login'),
  },
  {
    path: '/set_password',
    name: 'set password',
    meta: {
      auth: false,
      layout: 'Empty',
    },
    component: () => import('../views/PasswordChange'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      auth: true,
      layout: 'Navbar',
    },
    component: () => import('../views/Profile'),
  },
  {
    path: '/files',
    name: 'files',
    meta: {
      auth: true,
      layout: 'Navbar',
    },
    component: () => import('../components/FileExplorer'),
  },
  {
    path: '/monitoring',
    name: 'monitoring',
    meta: {
      auth: true,
      layout: 'Navbar',
    },
    component: () => import('../views/Monitoring'),
  },
  {
    path: '/phones',
    name: 'phones',
    meta: {
      auth: true,
      layout: 'Navbar',
    },
    component: () => import('../views/SentedCalls'),
  },
  {
    path: '/report',
    name: 'report',
    meta: {
      auth: true,
      layout: 'Navbar',
    },
    component: () => import('../views/Report'),
  },
  {
    path: '/',
    name: 'main',
    redirect: '/monitoring', // guard отправит на /login, если сессии нет
  },

  // {
  //   path: "/car/:carRoute",
  //   name: "car",
  //   meta: {
  //     auth: true,
  //     layout: 'empty',
  //   },
  //   component: () => import('../views/Car'),
  // },

  // {
  //   path: '*',
  //   name: '404',
  //   meta: {
  //     auth: true,
  //     layout: 'empty',
  //   },
  //   component: () => import('../views/404'),
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    //to, from, savedPosition
    return { x: 0, y: 0 }
  },
})

// При первой навигации восстанавливаем сессию с сервера (cookie), чтобы F5 не выкидывал на /login
let sessionChecked = false
router.beforeEach(async (to, from, next) => {
  const requireAuth = to.matched.some((record) => record.meta.auth)
  if (requireAuth && !store.getters.userAuth && !sessionChecked) {
    sessionChecked = true
    try {
      const { data } = await $host.get('/auth/login')
      store.commit('updateAuth', !!data.status)
      if (data.status) store.commit('updateUser', data.user)
    } catch (e) {
      console.log(e)
    }
  }
  if (requireAuth && !store.getters.userAuth) next('/login')
  else next()
})

export default router
